
import {
  Component, Prop, PropSync, Mixins,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import { PartItem } from '@/features/shipment/types';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import PartsBookItem from './PartsBookItem.vue';

@Component({
  components: {
    PartsBookItem,
  },
})
export default class PartsBookTable extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) partsBook!: PartItem[];

  @PropSync('loading', { required: false, default: false }) loadingSync!: boolean;

  get itemHeight(): number {
    if (this.isDesktop) {
      return 77;
    }

    return this.isMobile ? 170 : 100;
  }

  private fetchMorePartsBookItem(event) {
    this.debounceFetchPartsBook(event);
  }

  private debounceFetchPartsBook = debounce(this.fetchAndCommitPartsBook, 200);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async fetchAndCommitPartsBook(event: any): Promise<void> {
    const element = event.currentTarget || event.target;
    if (element && element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.$emit('fetchMore');
    }
  }
}
